module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h1', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780865477377_sofa.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_ack_r1.htm"
    }
  }, [_vm._v("Acknowledgments")]), _c('br'), _c('br'), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c01_r1.htm"
    }
  }, [_c('strong', [_vm._v("I    CODY ON THE COUCH")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which the author confronts his son’s laziness—and remembers his own, past and present—with comments on welfare queens, workfare, and preemployment testing—the emotional nature of the work ethic—work in the ancient world—Tocqueville, Thoreau, and Whitman on work in America and the trouble with fathers—slacker movies—academic work and other questionable labors—answers to “What makes good work good?” and “What did Jesus do?”—hippies and other dropouts—and the Way of the Slacker.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c02_r1.htm"
    }
  }, [_c('strong', [_vm._v("II   THE IDLER AND HIS WORKS")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which the “Idler,” the world’s first slacker, appears in 1758—Benjamin Franklin and Samuel Johnson usher in the modern world—and the Agricultural and Industrial Revolutions reshape the nature of work.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c03_r1.htm"
    }
  }, [_c('strong', [_vm._v("III   LOUNGERS, ROMANTICS, AND RIP VAN WINKLE")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which the Lounger, the Idler’s spiritual brother, appears toward the end of the eighteenth century—Meander, Abel Slug, Esq., and other icons of lounging have their say—and Rip Van Winkle sleeps through his career.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c04_r1.htm"
    }
  }, [_c('strong', [_vm._v("IV   LOAFERS, COMMUNISTS, DRINKERS, AND BOHEMIANS")])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which the Romantic hero, the loafer, and other odd variants in the early nineteenth century make their appearance—Karl Marx’s son-in-law thinks the old man works too much—workers like to leave for a drink at the bar several times a day—the campaign for shorter hours starts to make headway—Herman Melville loafs in the South Seas—Bartleby the Scrivener “prefers not to”—and Bohemia arrives in America.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c05_r1.htm"
    }
  }, [_c('strong', [_vm._v("V   NERVE CASES, SAUNTERERS, TRAMPS, AND "), _c('em', [_vm._v("FLÂNEURS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which the doctors decide that overwork is a problem—Jerome K. Jerome takes a leisure trip up the Thames—the")]), _vm._v(" flâneur "), _c('em', [_vm._v("and Saunterer make their bows—Oscar Wilde declares that doing nothing is the height of human achievement—the tramp becomes a hero and a social problem—and Theodore Dreiser flirts with failure but decides to work instead.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c06_r1.htm"
    }
  }, [_c('strong', [_vm._v("VI   SPORTS, FLAPPERS, BABBITTS, AND BUMS")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which the slacker becomes the villain of World War I and the hero of modernist literature—more fathers and sons—work goes out of fashion for the poor and becomes fashionable for the rich—booms and busts—Americans are told they need to “Sweat or Die!”—The")]), _vm._v(" Great Gatsby "), _c('em', [_vm._v("shows how to reconcile Benjamin Franklin and Samuel Johnson in modern times—and AI Jolson sings “Hallelujah, I’m a Bum!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c07_r1.htm"
    }
  }, [_c('strong', [_vm._v("VII   BEATS, NONCONFORMISTS, PLAYBOYS, AND DELINQUENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which new generations of the disaffected reinvent the slacker wheel as the world of work changes once again—Jack Kerouac and his dad have a falling out—the Man in the Gray Flannel Suit gets ahead and feels bad-Organization Man, white-collar workers, and other conformist losers—and women try on the flight from commitment.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c08_r1.htm"
    }
  }, [_c('strong', [_vm._v("VIII   DRAFT DODGERS, SURFERS, TV BEATNIKS,"), _c('br'), _vm._v("\n             AND HIPPIE COMMUNARDS")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which George W. Bush tries to go")]), _vm._v(" mano a mano "), _c('em', [_vm._v("with Pappy—waves of new slacker types cycle through popular culture and hip subcultures—Maynard G. Krebs, Gidget, Abbie Hoffman, and Baba Ram Dass—dropping out—back to the farm—communal slacking—stealing books—and other ways to get money for nothing.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_c09_r1.htm"
    }
  }, [_c('strong', [_vm._v("IX   SLACKERS")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent2"
  }, [_c('em', [_vm._v("In which slackers finally get their proper name—the game room rules the workplace—kids make movies instead of working—the Church of the Sub-Genius reinvents the lounger—the slacker novel has yet another renaissance—we visit the slackers of Japan and find that globalization in fact has made us all kin—the poor stay poor—the Internet and Anna Nicole Smith show us the Way of the Slacker—and the author reports that his son, Cody, has left the couch.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_bib_r1.htm"
    }
  }, [_vm._v("Bibliography")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780865477377_epub_ind_r1.htm"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fef178e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780865477377_epub_toc_r1.vue
// module id = 72
// module chunks = 0